import React, { useEffect, useState } from "react";
import "./loading.css"
import { RiLoader4Fill } from "react-icons/ri";

const Loading = () => {
    const [show,setShow]  = useState(false)
    useEffect(() => {
        setTimeout(() => {
            setShow(true)
        },100)
    })
    return (
        <>{show && <div className="containerLoading midText">
        <RiLoader4Fill className="circle" size={30} />
        Chargement
    </div>}</>)
}

export default Loading